import { create } from 'zustand';
import { message } from 'antd';
import { fetchFeed, hasFeedSearchFilter } from '../../../services/appOrgProjectApi';
import useNodesProjectStore from './useNodesProjectStore';
import {
  computeNextProductState,
  computePrevProductState,
  computeSelectProductIndex,
  computeFeedPageIndex,
} from '../utils/feedProductNavigation';

const initialNodesFeedState = {
  feedPage: null,
  reloadingProducts: false,
  productFields: {},
  feedPageIndex: 0,
  productIndex: 0,
  product: null,
  feedSearchEmptyResult: false,
  feedListQuery: {},
};

const useNodesFeedStore = create((set, get) => ({
  ...initialNodesFeedState,

  reset: () => set({ ...initialNodesFeedState }),

  clearFeedListQuery: () => set({ feedListQuery: {} }),

  resetFeedSearch: async () => {
    const { feedListQuery, feedPageIndex } = get();
    if (!hasFeedSearchFilter(feedListQuery)) return;
    get().clearFeedListQuery();
    await get().loadFeed(feedPageIndex);
  },

  loadFeed: async (pageIndex) => {
    const { project, feedId } = useNodesProjectStore.getState();
    const { feedListQuery = {} } = get();
    if (!project) return;
    set({ reloadingProducts: true, feedSearchEmptyResult: false });
    try {
      const data = await fetchFeed({
        feedId,
        pageNum: pageIndex,
        productId: feedListQuery.productId,
        searchField: feedListQuery.searchField,
        searchValue: feedListQuery.searchValue,
      });
      set({ feedPage: data });

      if (hasFeedSearchFilter(feedListQuery) && !data?.products?.length) {
        set({ feedSearchEmptyResult: true, product: null });
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      set({ reloadingProducts: false });
    }
  },

  setProduct: (product) => set({ product }),
  setProductIndex: (productIndex) => set({ productIndex }),
  setFeedPageIndex: (feedPageIndex) => set({ feedPageIndex }),
  setProductFields: (productFields) => set({ productFields }),

  toNextProduct: (step = 1) => {
    const { feedPage, productIndex, feedPageIndex } = get();
    set(computeNextProductState(feedPage, productIndex, feedPageIndex, step));
  },

  toPrevProduct: (step = 1) => {
    const { feedPage, productIndex, feedPageIndex } = get();
    set(computePrevProductState(feedPage, productIndex, feedPageIndex, step));
  },

  toSelectProduct: (index) => set(computeSelectProductIndex(index)),

  toFeedPageSelect: (page) => set(computeFeedPageIndex(page)),

  searchProductById: async (productId, searchField, searchValue) => {
    const { project, feedId } = useNodesProjectStore.getState();
    if (!project || !feedId) return;
    set({
      feedListQuery: { productId, searchField, searchValue },
      feedPageIndex: 0,
      productIndex: 0,
    });
    await get().loadFeed(0);
  },
}));

export default useNodesFeedStore;
